export const mapColorPalette = [
    '#002E53',
    '#01487D',
    '#195990',
    '#27659D',
    '#3471AA',
    '#407DB7',
    '#5895D1',
    '#77B5F2',
    '#9BCDFF',
    '#DAECFF',
  ]